import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BiometryCreateComponent } from './biometry-create.component';



@NgModule({
  declarations: [
    BiometryCreateComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class BiometryCreateModule { }
